import type { QueryClient } from '@tanstack/react-query';

import type { UploadKind } from '@/context/upload-state';

/** List and detail query keys per content kind, so a new kind is a row here rather than a branch. */
const CONTENT_QUERY_KEYS: Record<UploadKind, Array<string>> = {
  sermon: ['GetSermonsV2', 'GetSermonByGuid'],
  video: ['GetVideosV2', 'GetVideoByGuid'],
};

/**
 * Invalidates the list and detail queries for one content kind so mounted pages refetch.
 *
 * @param queryClient - React Query client instance.
 * @param kind - Which content the caches belong to. Undefined behaves as `'sermon'`, matching
 * `UploadSession.kind`, which is optional for sessions created before the videos flow existed.
 * @example
 * await invalidateContentCaches(queryClient, 'video');
 */
export async function invalidateContentCaches(queryClient: QueryClient, kind: UploadKind = 'sermon'): Promise<void> {
  await Promise.all(CONTENT_QUERY_KEYS[kind].map(queryKey => queryClient.invalidateQueries({ queryKey: [queryKey] })));
}
